import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAccount } from '../entities'
import '../client/Account.css'
import '../client/account-style.css'

export default function NoMatchPage() {
  const [account_data] = useAccount()
  const [state, setState] = useState({
    is_logo: false
  })
  return (
    <div className="client-app">
      <div className="app-container" id="app-layout">
        <div className="content-container">
          <div className="flex-side-bar" />
          <div className="flex-content">
            <div className="logo-container">
              {state.is_logo ? (
                <div className="img-logo">
                  <Link to="/">
                    <img
                      src="/assets/logo"
                      onError={() => setState({ ...state, is_logo: false })}
                      alt={
                        account_data.accountSettings
                          ? account_data.accountSettings.account_name
                          : ''
                      }
                    />
                  </Link>
                </div>
              ) : (
                <div className="text-logo">
                  <Link to="/">
                    {account_data.accountSettings
                      ? account_data.accountSettings.account_name
                      : ''}
                  </Link>
                </div>
              )}
            </div>
            <div id="app-messages-content" />
            <div>
              <h2>Not found</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
